import { render, staticRenderFns } from "./FormRO19.vue?vue&type=template&id=49b2a0c3"
import script from "./FormRO19.vue?vue&type=script&lang=js"
export * from "./FormRO19.vue?vue&type=script&lang=js"
import style0 from "./FormRO19.vue?vue&type=style&index=0&id=49b2a0c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports